import config from '@app/config';

export enum StickersCode {
  WarrantyBezuslovnayaCordiant = 'bezuslovnaya-garantiya-cordiant',
  WarrantyBezuslovnayaGislavedTorero = 'bezuslovnaya-garantiya-gislaved-i-torero',
  WarrantyBezuslovnayaNokian = 'bezuslovnaya-rasshirennaya-garantiya-nokian',
  WarrantyArmstrong = 'rasshirennaya-garantiya-armstrong',
  WarrantyContinental = 'rasshirennaya-garantiya-continental',
  WarrantyDoublestar = 'rasshirennaya-garantiya-doublestar',
  WarrantyFormula = 'rasshirennaya-garantiya-formula',
  WarrantyNokian = 'rasshirennaya-garantiya-nokian',
  WarrantyLandsail = 'rasshirennaya-garantiya-landsail',
  WarrantyMirage = 'rasshirennaya-garantiya-mirage',
  WarrantySatoya = 'rasshirennaya-garantiya-satoya',
  WarrantyViatti = 'rasshirennaya-garantiya-viatti',
  WarrantyPirelli = 'rasshirennaya-garantiya-pirelli',
  WarrantyUslovnayaCordiant = 'uslovnaya-garantiya-na-legkogruzovyie-shinyi-cordiant',
  FreeTireFitting = 'free-tire-fitting',
  Storage = 'storage',
}

export const pathStickers = {
  [StickersCode.WarrantyBezuslovnayaCordiant]: `${config.baseImageUrl}/upload/medialibrary/logotipyi/15_3012.svg`,
  [StickersCode.WarrantyBezuslovnayaGislavedTorero]: `${config.baseImageUrl}/upload/medialibrary/logotipyi/15_3013.svg`,
  [StickersCode.WarrantyBezuslovnayaNokian]: `${config.baseImageUrl}/upload/medialibrary/logotipyi/15_3014.svg`,
  [StickersCode.WarrantyArmstrong]: `${config.baseImageUrl}/upload/medialibrary/logotipyi/15_3015.svg`,
  [StickersCode.WarrantyContinental]: `${config.baseImageUrl}/upload/medialibrary/logotipyi/15_3016.svg`,
  [StickersCode.WarrantyDoublestar]: `${config.baseImageUrl}/upload/medialibrary/logotipyi/15_3017.svg`,
  [StickersCode.WarrantyFormula]: `${config.baseImageUrl}/upload/medialibrary/logotipyi/15_3018.svg`,
  [StickersCode.WarrantyNokian]: `${config.baseImageUrl}/upload/medialibrary/logotipyi/15_3019.svg`,
  [StickersCode.WarrantyLandsail]: `${config.baseImageUrl}/upload/medialibrary/logotipyi/15_3031.svg`,
  [StickersCode.WarrantyMirage]: `${config.baseImageUrl}/upload/medialibrary/logotipyi/15_3021.svg`,
  [StickersCode.WarrantySatoya]: `${config.baseImageUrl}/upload/medialibrary/logotipyi/15_3022.svg`,
  [StickersCode.WarrantyViatti]: `${config.baseImageUrl}/upload/medialibrary/logotipyi/15_3023.svg`,
  [StickersCode.WarrantyPirelli]: `${config.baseImageUrl}/upload/medialibrary/logotipyi/15_3024.svg`,
  [StickersCode.WarrantyUslovnayaCordiant]: `${config.baseImageUrl}/upload/medialibrary/logotipyi/15_3025.svg`,
  [StickersCode.FreeTireFitting]: `${config.baseImageUrl}/themes/tireshop2/assets/images/badgesProduct/BSM.svg`,
  [StickersCode.Storage]: `${config.baseImageUrl}/themes/tireshop2/assets/images/badgesProduct/hranenie.svg`,
};

export interface StickersConfigType {
  code: StickersCode;
  path: string;
  options: {
    width: number | string;
    height: number | string;
  };
}

export const stickersConfig: StickersConfigType[] = [
  {
    code: StickersCode.WarrantyBezuslovnayaCordiant,
    path: pathStickers[StickersCode.WarrantyBezuslovnayaCordiant],
    options: {
      width: 120,
      height: 120,
    },
  },
  {
    code: StickersCode.WarrantyBezuslovnayaGislavedTorero,
    path: pathStickers[StickersCode.WarrantyBezuslovnayaGislavedTorero],
    options: {
      width: 120,
      height: 120,
    },
  },
  {
    code: StickersCode.WarrantyBezuslovnayaNokian,
    path: pathStickers[StickersCode.WarrantyBezuslovnayaNokian],
    options: {
      width: 120,
      height: 120,
    },
  },
  {
    code: StickersCode.WarrantyArmstrong,
    path: pathStickers[StickersCode.WarrantyArmstrong],
    options: {
      width: 120,
      height: 120,
    },
  },
  {
    code: StickersCode.WarrantyContinental,
    path: pathStickers[StickersCode.WarrantyContinental],
    options: {
      width: 120,
      height: 120,
    },
  },
  {
    code: StickersCode.WarrantyDoublestar,
    path: pathStickers[StickersCode.WarrantyDoublestar],
    options: {
      width: 120,
      height: 120,
    },
  },
  {
    code: StickersCode.WarrantyFormula,
    path: pathStickers[StickersCode.WarrantyFormula],
    options: {
      width: 120,
      height: 120,
    },
  },
  {
    code: StickersCode.WarrantyNokian,
    path: pathStickers[StickersCode.WarrantyNokian],
    options: {
      width: 120,
      height: 120,
    },
  },
  {
    code: StickersCode.WarrantyLandsail,
    path: pathStickers[StickersCode.WarrantyLandsail],
    options: {
      width: 120,
      height: 120,
    },
  },
  {
    code: StickersCode.WarrantyMirage,
    path: pathStickers[StickersCode.WarrantyMirage],
    options: {
      width: 120,
      height: 120,
    },
  },
  {
    code: StickersCode.WarrantySatoya,
    path: pathStickers[StickersCode.WarrantySatoya],
    options: {
      width: 120,
      height: 120,
    },
  },
  {
    code: StickersCode.WarrantyViatti,
    path: pathStickers[StickersCode.WarrantyViatti],
    options: {
      width: 120,
      height: 120,
    },
  },
  {
    code: StickersCode.WarrantyPirelli,
    path: pathStickers[StickersCode.WarrantyPirelli],
    options: {
      width: 120,
      height: 120,
    },
  },
  {
    code: StickersCode.WarrantyUslovnayaCordiant,
    path: pathStickers[StickersCode.WarrantyUslovnayaCordiant],
    options: {
      width: 120,
      height: 120,
    },
  },
  {
    code: StickersCode.FreeTireFitting,
    path: pathStickers[StickersCode.FreeTireFitting],
    options: {
      width: 120,
      height: 40,
    },
  },
  // {
  //   code: StickersCode.Storage,
  //   path: pathStickers[StickersCode.Storage],
  //   options: {
  //     width: 120,
  //     height: 40,
  //   }
  // },
];
